import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgArrowOut = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="m7.227 5.957 7.044.616a.625.625 0 1 1-.11 1.245l-5.54-.485 4.999 5.958a.625.625 0 0 1-.958.803l-5-5.958-.483 5.542-.008.064a.626.626 0 0 1-1.24-.11l.003-.063.616-7.044.009-.063a.625.625 0 0 1 .604-.507z"
      />
    </svg>
  );
};
export default SvgArrowOut;
